module.exports = "/_next/static/images/curry_3_top-83ae1e600e909297a2119f5dcf397348.jpg";